import { IpBlockModel } from '@/http/models/IpBlock'

import { UseFetchListForm, useFetchList } from '@/hooks/useFetchList'

import { IpBlockHttpParams, IpBlockModel as IpBlockType } from '@/types'

export interface IpBlockListFilters {
  search?: string
}

export interface IpBlockListForm extends UseFetchListForm<
  IpBlockListFilters,
  IpBlockType.IpBlock
> {}

interface UseFetchIpBlocksProps {
  sort?: string | null
  shouldFetchList?: boolean
}

export const ipBlockInitialFilters: IpBlockListFilters = {
  search: '',
}

export const useFetchIpBlocks = ({ sort, shouldFetchList }: UseFetchIpBlocksProps) => {
  return useFetchList<
    IpBlockListFilters,
    IpBlockType.IpBlock,
    {},
    any,
    typeof IpBlockModel.getList
  >({
    pageSize: 10,
    initialFilters: ipBlockInitialFilters,
    fetchFunction: IpBlockModel.getList,
    sort,
    register: shouldFetchList,
    buildQueryParams: (filters): Partial<IpBlockHttpParams.GetList['query']> => ({
      search: filters.search || undefined,
    }),
    buildParams: () => ({}),
  })
}
